import React, { useState } from "react";
import { BootstrapModalWrapper, Button, Modal } from "components/bootstrap";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import InputProfileForm from "./InputProfileForm";
import { InputProfilesActions } from "../stores/InputProfilesStore";
const EditInputProfileForm = ({
  inputProfile,
  buttonBsStyle = "info",
  buttonBsSize = null,
  buttonText = "Edit",
  onSave
}) => {
  const [showModal, setShowModal] = useState(false);
  const sendTelemetry = useSendTelemetry();
  const _openModal = () => setShowModal(true);
  const _closeModal = () => setShowModal(false);
  const handleSubmit = (nextInputProfile) => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.FORWARDER.FORWARDER_INPUT_PROFILE_UPDATED, {
      app_pathname: "forwarder",
      app_section: "input-profile"
    });
    InputProfilesActions.update(nextInputProfile, inputProfile.id).then((result) => {
      onSave(result);
      return result;
    }).finally(_closeModal);
  };
  const modalTitle = inputProfile.id ? "Update input profile" : "Create input profile";
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Button, { bsStyle: buttonBsStyle, bsSize: buttonBsSize, onClick: _openModal }, buttonText), /* @__PURE__ */ React.createElement(BootstrapModalWrapper, { showModal, onHide: _closeModal, bsSize: "lg" }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, modalTitle)), /* @__PURE__ */ React.createElement(
    InputProfileForm,
    {
      inputProfile,
      onSubmit: handleSubmit,
      onCancel: _closeModal,
      buttonToolbarClassName: "pull-right",
      buttonText: "Update",
      InputsWrapper: Modal.Body,
      ActionsWrapper: Modal.Footer
    }
  )));
};
export default EditInputProfileForm;
